// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"select_wrapper__Ush_l","error":"select_error__xiGQs"};